// extracted by mini-css-extract-plugin
export default {"list":"styles_list__qLjro","item":"styles_item__bcXw3"};